// Get Discover Brands
export const GET_DISCOVER_BRANDS_REQUEST = 'GET_DISCOVER_BRANDS_REQUEST';
export const GET_DISCOVER_BRANDS_DONE = 'GET_DISCOVER_BRANDS_DONE';
export const GET_DISCOVER_BRANDS_FAILED = 'GET_DISCOVER_BRANDS_FAILED';
export const GET_DISCOVER_BRANDS_RESET = 'GET_DISCOVER_BRANDS_RESET';

// Operations
export const DISCOVER_BRANDS_SET_PAGE = 'DISCOVER_BRANDS_SET_PAGE';